<template>
  <div>
    <v-card>
      <v-card-title v-if="charge">
        Editar Cargo - {{ charge.name }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="formCarge" v-model="formCharge">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="model.name"
                  :rules="[this.$store.state.rules.required]"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  :items="this.$store.state.status.chargePermissions"
                  v-model="model.can_create_report"
                  :rules="[this.$store.state.rules.required]"
                  label="Puede Crear Reporte?"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  :items="this.$store.state.status.chargePermissions"
                  v-model="model.can_reviewer_report"
                  :rules="[this.$store.state.rules.required]"
                  label="Puede Editar Reporte?"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  :items="this.$store.state.status.chargePermissions"
                  v-model="model.can_add_statistics"
                  :rules="[this.$store.state.rules.required]"
                  label="Puede Agregar Estadisticas?"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  :items="this.$store.state.status.chargePermissions"
                  v-model="model.can_add_achievements"
                  :rules="[this.$store.state.rules.required]"
                  label="Puede Agregar Logros?"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  :items="this.$store.state.status.chargePermissions"
                  v-model="model.can_add_accompaniments"
                  :rules="[this.$store.state.rules.required]"
                  label="Puede Crear Acompañamientos?"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" md="12">
                <v-textarea
                  :items="this.$store.state.status.chargePermissions"
                  v-model="model.help_text"
                  :rules="[this.$store.state.rules.required]"
                  label="Texto de ayuda"
                  required
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-btn color="primary" @click="saveCharge"> Editar </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
import { SET_CHARGE } from "@/store/charge";
export default {
  name: "Edit",
  data: () => ({
    formCharge: true,
    charge: null,
    model: {
      name: "",
      monthly_salary: "",
      total_salary: "",
      duration: "",
      can_create_report: "",
      can_reviewer_report: "",
      can_add_statistics: "",
      can_add_achievements: "",
      can_add_accompaniments: "",
      help_text: "",
    },
  }),
  computed: {
    monthly_salary() {
      return this.model.monthly_salary;
    },
    total_salary() {
      return this.model.total_salary;
    },
  },
  watch: {
    monthly_salary(val) {
      if (parseInt(val) > 0) {
        val = val.split(".").join("");
        this.model.monthly_salary = new Intl.NumberFormat("de-DE").format(val);
      }
    },
    total_salary(val) {
      if (parseInt(val) > 0) {
        val = val.split(".").join("");
        this.model.total_salary = new Intl.NumberFormat("de-DE").format(val);
      }
    },
  },
  created() {
    this.$store.dispatch("getCharge", this.$route.params.id);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_CHARGE) {
        this.charge = state.charge.charge;
        this.setCharge();
      }
    });
  },
  methods: {
    setCharge() {
      this.model = {
        name: this.charge.name,
        can_create_report: this.charge.can_create_report.toString(),
        can_reviewer_report: this.charge.can_reviewer_report.toString(),
        can_add_statistics: this.charge.can_add_statistics
          ? this.charge.can_add_statistics.toString()
          : "0",
        can_add_achievements: this.charge.can_add_achievements
          ? this.charge.can_add_achievements.toString()
          : "0",
        can_add_accompaniments: this.charge.can_add_accompaniments
          ? this.charge.can_add_accompaniments.toString()
          : "0",
        help_text: this.charge.help_text,
      };
    },
    setNumber() {
      if (typeof this.model.monthly_salary === "string")
        this.model.monthly_salary = this.model.monthly_salary
          .split(".")
          .join("");

      if (typeof this.model.total_salary === "string")
        this.model.total_salary = this.model.total_salary.split(".").join("");
    },
    async saveCharge() {
      if (!this.$refs.formCarge.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.setNumber();
      this.$store.dispatch("updateCharge", {
        id: this.charge.id,
        form: this.model,
      });
    },
  },
};
</script>

<style>
</style>